// import React, { useMemo, useState, useEffect } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemText,
//   useMediaQuery,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
// import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
// import { useTheme } from "@mui/material/styles";

// const defaultConfig = {
//   restaurantName: "Restaurant",
//   logo: "",
//   primaryColor: "#c62828",
//   textColor: "#ffffff",
//   activeColor: "rgba(255,255,255,0.18)",
//   hoverColor: "rgba(255,255,255,0.10)",
//   mobileTextColor: "#222222",
//   routes: [
//     { label: "Home", path: "/" },
//     { label: "Menu", path: "/menu" },
//     { label: "About", path: "/about" },
//     { label: "Contact", path: "/contact" },
//     { label: "Cart", path: "/cart", icon: "cart" },
//   ],
// };

// const T1Navbar = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [activePath, setActivePath] = useState("/");

//   const config = useMemo(() => {
//     const params = new URLSearchParams(window.location.search);

//     let routes = defaultConfig.routes;
//     const routesParam = params.get("routes");

//     if (routesParam) {
//       try {
//         routes = JSON.parse(decodeURIComponent(routesParam));
//       } catch (error) {
//         routes = defaultConfig.routes;
//       }
//     }

//     return {
//       restaurantName:
//         params.get("restaurantName") || defaultConfig.restaurantName,
//       logo: params.get("logo") || defaultConfig.logo,
//       primaryColor: params.get("primaryColor") || defaultConfig.primaryColor,
//       textColor: params.get("textColor") || defaultConfig.textColor,
//       activeColor: params.get("activeColor") || defaultConfig.activeColor,
//       hoverColor: params.get("hoverColor") || defaultConfig.hoverColor,
//       mobileTextColor:
//         params.get("mobileTextColor") || defaultConfig.mobileTextColor,
//       routes,
//     };
//   }, []);

//   useEffect(() => {
//     const handleMessage = (event) => {
//       if (event?.data?.type === "PARENT_ROUTE_CHANGE") {
//         setActivePath(event.data.path || "/");
//       }
//     };

//     window.addEventListener("message", handleMessage);
//     return () => {
//       window.removeEventListener("message", handleMessage);
//     };
//   }, []);

//   const handleNavigation = (path) => {
//     setActivePath(path);

//     if (window.parent) {
//       window.parent.postMessage(
//         {
//           type: "IFRAME_NAVIGATE",
//           path,
//         },
//         "*"
//       );
//     }

//     setMobileOpen(false);
//   };

//   const renderDesktopRoutes = () =>
//     config.routes.map((route) => {
//       const isActive = activePath === route.path;

//       return (
//         <Button
//           key={route.path}
//           onClick={() => handleNavigation(route.path)}
//           startIcon={
//             route.icon === "cart" ? <ShoppingCartOutlinedIcon /> : null
//           }
//           sx={{
//             color: config.textColor,
//             textTransform: "none",
//             borderRadius: "10px",
//             px: 2,
//             py: 1,
//             fontWeight: isActive ? 700 : 500,
//             backgroundColor: isActive ? config.activeColor : "transparent",
//             "&:hover": {
//               backgroundColor: config.hoverColor,
//             },
//           }}
//         >
//           {route.label}
//         </Button>
//       );
//     });

//   const renderMobileRoutes = () =>
//     config.routes.map((route) => {
//       const isActive = activePath === route.path;

//       return (
//         <ListItemButton
//           key={route.path}
//           onClick={() => handleNavigation(route.path)}
//           sx={{
//             borderRadius: "10px",
//             mb: 0.5,
//             backgroundColor: isActive ? "rgba(0,0,0,0.05)" : "transparent",
//           }}
//         >
//           <ListItemText
//             primary={route.label}
//             primaryTypographyProps={{
//               fontWeight: isActive ? 700 : 500,
//               color: config.mobileTextColor,
//             }}
//           />
//         </ListItemButton>
//       );
//     });

//   return (
//     <>
//       <AppBar
//         position="static"
//         elevation={0}
//         sx={{
//           backgroundColor: config.primaryColor,
//           boxShadow: "none",
//           borderBottom: "1px solid rgba(255,255,255,0.12)",
//         }}
//       >
//         <Toolbar
//           sx={{
//             minHeight: { xs: 64, md: 72 },
//             display: "flex",
//             justifyContent: "space-between",
//             px: { xs: 2, md: 3 },
//             gap: 2,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1.2,
//               minWidth: 0,
//             }}
//           >
//             {config.logo ? (
//               <Box
//                 component="img"
//                 src={config.logo}
//                 alt={config.restaurantName}
//                 sx={{
//                   width: 42,
//                   height: 42,
//                   borderRadius: "50%",
//                   objectFit: "cover",
//                   border: "1px solid rgba(255,255,255,0.25)",
//                 }}
//               />
//             ) : (
//               <Box
//                 sx={{
//                   width: 42,
//                   height: 42,
//                   borderRadius: "12px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   backgroundColor: "rgba(255,255,255,0.14)",
//                   border: "1px solid rgba(255,255,255,0.20)",
//                 }}
//               >
//                 <RestaurantMenuIcon sx={{ color: config.textColor }} />
//               </Box>
//             )}

//             <Box sx={{ minWidth: 0 }}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   color: config.textColor,
//                   fontWeight: 700,
//                   lineHeight: 1.1,
//                   fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                   whiteSpace: "nowrap",
//                   maxWidth: { xs: 170, sm: 240, md: 320 },
//                 }}
//               >
//                 {config.restaurantName}
//               </Typography>

//               <Typography
//                 variant="caption"
//                 sx={{
//                   color: "rgba(255,255,255,0.85)",
//                   display: "block",
//                   fontSize: "0.72rem",
//                 }}
//               >
//                 Powered by RMTApp
//               </Typography>
//             </Box>
//           </Box>

//           {isMobile ? (
//             <IconButton
//               onClick={() => setMobileOpen(true)}
//               sx={{ color: config.textColor }}
//             >
//               <MenuIcon />
//             </IconButton>
//           ) : (
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//               {renderDesktopRoutes()}
//             </Box>
//           )}
//         </Toolbar>
//       </AppBar>

//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={() => setMobileOpen(false)}
//         PaperProps={{
//           sx: {
//             width: 280,
//             p: 2,
//           },
//         }}
//       >
//         <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
//           {config.restaurantName}
//         </Typography>

//         <List sx={{ p: 0 }}>{renderMobileRoutes()}</List>
//       </Drawer>
//     </>
//   );
// };

// export default T1Navbar;


import React, { useEffect, useMemo, useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Avatar,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useTheme } from "@mui/material/styles";

const DEFAULT_ROUTES = {
  guest: [
    { label: "Home", path: "/" },
    { label: "Menu", path: "/menu" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
    { label: "Login", path: "/login" },
    { label: "Sign Up", path: "/signup" },
    { label: "Cart", path: "/cart", icon: "cart" },
  ],
  loggedIn: [
    { label: "Home", path: "/" },
    { label: "Menu", path: "/menu" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
    { label: "Profile", path: "/profile", icon: "profile" },
    { label: "Cart", path: "/cart", icon: "cart" },
  ],
};

const T1Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [mobileOpen, setMobileOpen] = useState(false);
  const [activePath, setActivePath] = useState("/");
  const [isLogged, setIsLogged] = useState(false);

  const config = useMemo(() => {
    const params = new URLSearchParams(window.location.search);

    return {
      restaurantName: params.get("restaurantName") || "Restaurant",
      logo: params.get("logo") || "",
      primaryColor: params.get("primaryColor") || "#b71c1c",
      textColor: params.get("textColor") || "#ffffff",
      activeColor: params.get("activeColor") || "rgba(255,255,255,0.18)",
      hoverColor: params.get("hoverColor") || "rgba(255,255,255,0.10)",
      mobileTextColor: params.get("mobileTextColor") || "#222222",
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (!event?.data) return;

      if (event.data.type === "PARENT_ROUTE_CHANGE") {
        setActivePath(event.data.path || "/");
      }

      if (event.data.type === "PARENT_LOGIN_STATUS") {
        setIsLogged(Boolean(event.data.isLogged));
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const routes = useMemo(() => {
    return isLogged ? DEFAULT_ROUTES.loggedIn : DEFAULT_ROUTES.guest;
  }, [isLogged]);

  const handleNavigation = (path) => {
    setActivePath(path);

    if (window.parent) {
      window.parent.postMessage(
        {
          type: "IFRAME_NAVIGATE",
          path,
        },
        "*"
      );
    }

    setMobileOpen(false);
  };

  const renderRouteIcon = (icon) => {
    if (icon === "cart") {
      return <ShoppingCartOutlinedIcon sx={{ fontSize: 20 }} />;
    }

    if (icon === "profile") {
      return <AccountCircleOutlinedIcon sx={{ fontSize: 20 }} />;
    }

    return null;
  };

  const renderDesktopRoutes = () =>
    routes.map((route) => {
      const isActive = activePath === route.path;

      return (
        <Button
          key={route.path}
          onClick={() => handleNavigation(route.path)}
          startIcon={renderRouteIcon(route.icon)}
          sx={{
            color: config.textColor,
            textTransform: "none",
            borderRadius: "10px",
            px: 2,
            py: 1,
            fontWeight: isActive ? 700 : 500,
            backgroundColor: isActive ? config.activeColor : "transparent",
            "&:hover": {
              backgroundColor: config.hoverColor,
            },
          }}
        >
          {route.label}
        </Button>
      );
    });

  const renderMobileRoutes = () =>
    routes.map((route) => {
      const isActive = activePath === route.path;

      return (
        <ListItemButton
          key={route.path}
          onClick={() => handleNavigation(route.path)}
          sx={{
            borderRadius: "10px",
            mb: 0.5,
            backgroundColor: isActive ? "rgba(0,0,0,0.05)" : "transparent",
          }}
        >
          <ListItemText
            primary={route.label}
            primaryTypographyProps={{
              fontWeight: isActive ? 700 : 500,
              color: config.mobileTextColor,
            }}
          />
        </ListItemButton>
      );
    });

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: config.primaryColor,
          boxShadow: "none",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 64, md: 72 },
            display: "flex",
            justifyContent: "space-between",
            px: { xs: 2, md: 3 },
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              minWidth: 0,
            }}
          >
            {config.logo ? (
              <Box
                component="img"
                src={config.logo}
                alt={config.restaurantName}
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "1px solid rgba(255,255,255,0.25)",
                }}
              />
            ) : (
              <Box
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255,255,255,0.14)",
                  border: "1px solid rgba(255,255,255,0.20)",
                }}
              >
                <RestaurantMenuIcon sx={{ color: config.textColor }} />
              </Box>
            )}

            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h6"
                sx={{
                  color: config.textColor,
                  fontWeight: 700,
                  lineHeight: 1.1,
                  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: { xs: 170, sm: 240, md: 320 },
                }}
              >
                {config.restaurantName}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  color: "rgba(255,255,255,0.85)",
                  display: "block",
                  fontSize: "0.72rem",
                }}
              >
                Powered by RMTApp
              </Typography>
            </Box>
          </Box>

          {isMobile ? (
            <IconButton
              onClick={() => setMobileOpen(true)}
              sx={{ color: config.textColor }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {renderDesktopRoutes()}

              {isLogged && (
                <Avatar
                  sx={{
                    width: 34,
                    height: 34,
                    bgcolor: "rgba(255,255,255,0.18)",
                    color: config.textColor,
                    ml: 0.5,
                  }}
                >
                  P
                </Avatar>
              )}
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{
          sx: {
            width: 280,
            p: 2,
          },
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          {config.restaurantName}
        </Typography>

        <List sx={{ p: 0 }}>{renderMobileRoutes()}</List>
      </Drawer>
    </>
  );
};

export default T1Navbar;